<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <span class=" mr-auto">
    <button mat-raised-button routerLink="/hazards" class="m-1 mr-2">
      <mat-icon>arrow_back</mat-icon> Hazard & Risk Templates
    </button>
  </span>
</nav>

<mat-tab-group>
  <mat-tab label="Details">
    <div class="container-fluid p-3">
      <div class="row">
        <div class="col-12 col-md-6">
          <ng-container *ngIf="hazard.name">
            <h6>Hazard/Risk</h6>
            <p>{{ hazard.name }}</p>
          </ng-container>

          <ng-container *ngIf="hazard.description">
            <h6>Description</h6>
            <p>{{ hazard.description }}</p>
          </ng-container>

          <ng-container>
            <h6>Significant</h6>
            <p>{{ hazard.significant ? 'Yes' : 'No' }}</p>
          </ng-container>

          <ng-container *ngIf="hazard.status">
            <h6>Status</h6>
            <p>{{ hazard.status }}</p>
          </ng-container>

          <ng-container *ngIf="hazard.ira_likelihood && hazard.ira_severity">
            <h6>Initial Risk Assessment Score</h6>
            <p>
              <span [class]="utils.getSiteRiskStatusTextColor(hazard.ira_score_band ?? utils.getRiskAssessmentText(hazard.ira_likelihood, hazard.ira_severity))">
                 {{ hazard.ira_score ?? utils.calculateRiskScore(hazard.ira_likelihood, hazard.ira_severity) }}
              </span>
            </p>
          </ng-container>

          <ng-container *ngIf="hazard.ira_likelihood && hazard.ira_severity">
            <h6>Initial Risk Assessment</h6>
            <p>
              <span [class]="utils.getSiteRiskStatusTextColor(hazard.ira_score_band ?? utils.getRiskAssessmentText(hazard.ira_likelihood, hazard.ira_severity))">
                {{ hazard.ira_score_band ?? utils.getRiskAssessmentText(hazard.ira_likelihood, hazard.ira_severity) }}
              </span>
            </p>
          </ng-container>

          <ng-container *ngIf="hazard.rra_likelihood && hazard.rra_severity">
            <h6>Residual Risk Assessment Score</h6>
            <p>
              <span [class]="utils.getSiteRiskStatusTextColor(hazard.rra_score_band ?? utils.getRiskAssessmentText(hazard.rra_likelihood, hazard.rra_severity))">
                {{ hazard.rra_score ?? utils.calculateRiskScore(hazard.rra_likelihood, hazard.rra_severity) }}
              </span>
            </p>
          </ng-container>

          <ng-container *ngIf="hazard.rra_likelihood && hazard.rra_severity">
            <h6>Residual Risk Assessment</h6>
            <p>
              <span [class]="utils.getSiteRiskStatusTextColor(hazard.rra_score_band ?? utils.getRiskAssessmentText(hazard.rra_likelihood, hazard.rra_severity))">
                {{ hazard.rra_score_band ?? utils.getRiskAssessmentText(hazard.rra_likelihood, hazard.rra_severity) }}
              </span>
            </p>
          </ng-container>

          <ng-container *ngIf="hazard.controls.length">
            <h6>Hazard/Risk Controls</h6>

            <p *ngFor="let control of hazard.controls; let i = index">
              <ng-container *ngIf="control && control?.control && control?.loc">
                <b>{{ i + 1 }} - {{ control.control }}</b> <br />
                {{ loc_list[control.loc - 1] }}
              </ng-container>
            </p>
          </ng-container>

          <ng-container *ngIf="hazard?.reviewer">
            <h6>Reviewer</h6>
            <p id="reviewed-by">
              <a (click)="onUserPublicView(hazard.reviewer.hash)"
                 matTooltip="View User Public Profile">
                {{ hazard.reviewer.contact_person }}
              </a>
            </p>
          </ng-container>

          <ng-container *ngIf="hazard.reviewer_date">
            <h6>Review Date</h6>
            <p id="reviewed-date">{{ hazard.reviewer_date * 1000 | date:'medium' }}</p>
          </ng-container>

          <ng-container *ngIf="hazard.last_reviewer_date">
            <h6>Last Review Date</h6>
            <p id="last-reviewed-date">{{ hazard.last_reviewer_date * 1000 | date:'medium' }}</p>
          </ng-container>

          <ng-container *ngIf="hazard?.asset && hazard?.asset?.id">
            <h6>Related Asset</h6>
            <p>
              <a (click)="onViewAsset(hazard.asset.id)" matTooltip="View this asset">
                {{ hazard.asset.name }}<span *ngIf="hazard.asset.code"> ({{ hazard.asset.code }})</span>
              </a>
            </p>
          </ng-container>

          <ng-container>
            <h6>Created By</h6>
            <p>
              <a (click)="onUserPublicView(hazard.created_by_hash)"
                 matTooltip="View User Public Profile">
                {{ hazard.created_by_name }}
              </a>
            </p>
          </ng-container>
        </div>
        <div class="col-12 col-md-6"></div>
      </div>
    </div>
  </mat-tab>

  <mat-tab label="Files">
    <div class="container-fluid p-0">
      <div class="mat-elevation-z8">
        <ng-container *ngIf="media?.length">
          <app-files-list [view]="true" [files]="media"></app-files-list>
        </ng-container>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>
